
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/joy-ui/api/accordion-summary",
      function () {
        return require("private-next-pages/joy-ui/api/accordion-summary.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/joy-ui/api/accordion-summary"])
      });
    }
  